import { render, staticRenderFns } from "./orders.html?vue&type=template&id=a1033980&scoped=true&"
import script from "./orders.js?vue&type=script&lang=js&"
export * from "./orders.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1033980",
  null
  
)

export default component.exports